module.exports = new __parcel__URL__("smog-city.7283374c.png").toString();